import { render } from "./BusinessByClientTable.vue?vue&type=template&id=991ca0f4&scoped=true"
import script from "./BusinessByClientTable.vue?vue&type=script&lang=js"
export * from "./BusinessByClientTable.vue?vue&type=script&lang=js"

import "./BusinessByClientTable.vue?vue&type=style&index=0&id=991ca0f4&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-991ca0f4"]])

export default __exports__